import * as React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';
import RoleGate from 'components/RoleGate';
import { Roles } from 'components/RoleGate/types';

export interface Props {
    children: React.ReactNode;
    requiredRoles: Roles[];
}

/**
 * A component that adds selectable prop to Table if the user has permission.
 */
export class RoleTable extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { children, requiredRoles } = this.props;

        return (
            <RoleGate
                requiredRoles={requiredRoles}
                fallback={
                    <Table sortable striped singleLine unstackable size="small">
                        {children}
                    </Table>
                }
            >
                <Table
                    sortable
                    striped
                    singleLine
                    unstackable
                    size="small"
                    selectable
                >
                    {children}
                </Table>
            </RoleGate>
        );
    }
}

export default connect(
    null,
    { updateQueryString }
)(RoleTable);
